import type { TaskWithRelations } from "@/hooks/useTasks";

export const TASK_INDEX_SORTS = [
  { value: "due", label: "Due date" },
  { value: "title", label: "Task A–Z" },
  { value: "created", label: "Newest created" },
] as const;
export type TaskIndexSort = typeof TASK_INDEX_SORTS[number]["value"];
export const TASK_INDEX_COLUMNS = ["project", "due", "assignee", "dependencies", "status"] as const;
export const DEFAULT_TASK_COLUMNS = "project,due,assignee,status";
export const TASK_PAGE_SIZE = 15;
export const isTaskUuid = (value: string | null | undefined): value is string =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value ?? "");
export const parseTaskSort = (value: string | null): TaskIndexSort =>
  TASK_INDEX_SORTS.some((sort) => sort.value === value) ? value as TaskIndexSort : "due";
export const parseTaskPage = (value: string | null) => Math.max(1, Number.parseInt(value ?? "1", 10) || 1);
export function parseTaskColumns(value: string | null): string {
  if (value === null) return DEFAULT_TASK_COLUMNS;
  const requested = new Set(value === "none" ? [] : value.split(","));
  return TASK_INDEX_COLUMNS.filter((id) => requested.has(id)).join(",") || "none";
}

export function sortTaskIndex(tasks: readonly TaskWithRelations[], sort: TaskIndexSort): TaskWithRelations[] {
  return [...tasks].sort((a, b) => {
    const order = sort === "title" ? a.title.localeCompare(b.title, undefined, { numeric: true })
      : sort === "created" ? b.created_at.localeCompare(a.created_at)
      : a.due_date === b.due_date ? 0 : !a.due_date ? 1 : !b.due_date ? -1 : a.due_date.localeCompare(b.due_date);
    return order || b.created_at.localeCompare(a.created_at) || a.id.localeCompare(b.id);
  });
}

/** Carry the complete list state to the record and its collection breadcrumb. */
export function taskRecordHref(id: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete("taskId");
  params.delete("quick");
  params.delete("create");
  const query = params.toString();
  return `/tasks/${encodeURIComponent(id)}${query ? `?${query}` : ""}`;
}
export function taskCollectionHref(search: string): string {
  const params = new URLSearchParams(search);
  params.delete("taskId");
  params.delete("quick");
  params.delete("create");
  const query = params.toString();
  return `/tasks${query ? `?${query}` : ""}`;
}
